export default __webpack_public_path__ + "media/main_banner_en.293b3b33.png";